const _ = "adyen-pe-button", T = "adyen-pe-button__anchor", N = `${_}-actions`, A = `${_}--icon`, n = `${_}--icon-content`, o = `${N}__container-wrapper`, S = `${_}__label`, t = `${_}__icon-right`, O = `${_}__icon-left`, C = `${_}--condensed`, c = `${_}--full-width`, E = `${_}--loading`;
export {
  N as BUTTON_ACTION_CLASSNAME,
  o as BUTTON_ACTION_CONTAINER_CLASSNAME,
  T as BUTTON_ANCHOR_CLASSNAME,
  C as BUTTON_CONDENSED_CLASSNAME,
  c as BUTTON_FULL_WIDTH_CLASSNAME,
  O as BUTTON_ICON_LEFT_CLASSNAME,
  t as BUTTON_ICON_RIGHT_CLASSNAME,
  S as BUTTON_LABEL_CLASSNAME,
  E as BUTTON_LOADING_CLASSNAME,
  _ as DEFAULT_BUTTON_CLASSNAME,
  A as ICON_BUTTON_CLASSNAME,
  n as ICON_BUTTON_CONTENT_CLASSNAME
};
